import { useRef } from 'react';
import Modal from 'ui3/Modal/Modal';
import Button from 'ui3/Button/Button';
import Text from 'ui3/Text/Text';
import { SocialIntegrationErrorDialogData } from 'helpers/social-integration-errors';
import styles from './SocialIntegrationErrorModal.module.scss';

type SocialIntegrationErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  error?: SocialIntegrationErrorDialogData | null;
};

const SocialIntegrationErrorModal = ({
  isOpen,
  onClose,
  error,
}: SocialIntegrationErrorModalProps) => {
  const lastErrorRef = useRef(error);

  if (error) {
    lastErrorRef.current = error;
  }

  const displayError = error ?? lastErrorRef.current;

  if (!displayError) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={displayError.title}
      subTitle={displayError.subTitle}
      size="small"
      closeOnOverlayClick={false}
      showCloseIcon={false}
    >
      <div className={styles.content}>
        <div className={styles.emptyState}>
          <Text variant="body1Regular16" color="lights-low" textAlign="center">
            {displayError.message}
          </Text>
        </div>
        <div className={styles.actions}>
          <Button variant="primary" onClick={onClose} block>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SocialIntegrationErrorModal;
